import { pagesPath } from "@/utils/pages-path";
import { PagesPathname } from "./types";

export const pageTitles = {
  // Admin（/admin）
  [pagesPath.admin.list.members.import.$url().pathname]: "加入者インポート",
  [pagesPath.admin.list.members.elderly_benefits_card.$url().pathname]:
    "高齢受給者管理簿インポート",
  [pagesPath.admin.list.members.memo.$url().pathname]: "台帳メモインポート",
  [pagesPath.admin.list.offices.import.$url().pathname]: "事業所インポート",
  [pagesPath.admin.list.offices.account.$url().pathname]:
    "事業所アカウントインポート",
  [pagesPath.admin.list.admins.$url().pathname]: "健保スタッフ管理",
  [pagesPath.admin.list.admins.allowed_emails.$url().pathname]:
    "健保許可メール管理",
  [pagesPath.admin.list.admins.roles.$url().pathname]: "ロールと権限の一覧",
  [pagesPath.admin.list.members.$url().pathname]: "加入者一覧",

  // 通知（メール・サイト内通知）
  [pagesPath.admin.list.notifications.$url().pathname]: "通知管理",
  [pagesPath.admin.list.notifications.system.$url().pathname]:
    "システム通知設定",
  [pagesPath.admin.list.notifications.system._notificationTypeCode("").$url()
    .pathname]: "システム通知設定 詳細",
  [pagesPath.admin.list.notifications.email.$url().pathname]: "メール通知管理",
  [pagesPath.admin.list.notifications.email.address_books.$url().pathname]:
    "アドレス帳一覧",
  [pagesPath.admin.list.notifications.email.address_books._id("").$url()
    .pathname]: "アドレス帳詳細",
  [pagesPath.admin.list.notifications.email.address_books._id("").entries.$url()
    .pathname]: "アドレス帳宛先一覧",
  [pagesPath.admin.list.notifications.email.address_books.new.$url().pathname]:
    "アドレス帳新規作成",
  [pagesPath.admin.list.notifications.email.email_compose.$url().pathname]:
    "下書き作成",
  [pagesPath.admin.list.notifications.email.email_compose._id("").$url()
    .pathname]: "下書き編集",
  [pagesPath.admin.list.notifications.email.deliveries.$url().pathname]:
    "配信一覧",
  [pagesPath.admin.list.notifications.email.deliveries._id("").$url().pathname]:
    "配信詳細",
  [pagesPath.admin.list.notifications.email.deliveries._id("").entries.$url()
    .pathname]: "配信済みアドレス一覧",
  [pagesPath.admin.list.notifications.email.email_delivery._id("").$url()
    .pathname]: "配信設定",

  [pagesPath.admin.list.notifications.employer_email.$url().pathname]:
    "事業所向けメール通知",
  [pagesPath.admin.list.notifications.employer_email.new.$url().pathname]:
    "新規作成",
  [pagesPath.admin.list.notifications.employer_email
    ._notificationTypeCode("_")
    .$url().pathname]: "事業所向けメール通知 詳細",

  [pagesPath.admin.list.notifications.in_app.$url().pathname]:
    "サイト内通知設定",
  [pagesPath.admin.list.notifications.in_app.new.$url().pathname]: "新規作成",
  [pagesPath.admin.list.notifications.in_app._notificationTypeCode("").$url()
    .pathname]: "サイト内通知設定 詳細",

  [pagesPath.admin.list.offices.$url().pathname]: "事業所管理",
  [pagesPath.admin.list.character_conversion_rules.$url().pathname]:
    "加入者の認証時のマイナアプリの文字変換ルール管理",
  [pagesPath.admin.list.deleted_records.$url().pathname]: "削除済みデータ管理",
  [pagesPath.admin.list.offices._officeId("").users.$url().pathname]:
    "事業所ユーザー",
  [pagesPath.admin.list.offices._officeId("").invitation.$url().pathname]:
    "事業所ユーザー招待",
  [pagesPath.admin.list.offices._officeId("").domains.$url().pathname]:
    "事業所ドメイン",
  [pagesPath.admin.list.offices._officeId("").office_information.$url()
    .pathname]: "事業所登録情報",
  [pagesPath.admin.list.accounts.$url().pathname]: "アカウント一覧",
  [pagesPath.admin.list.bank_accounts.offices.$url().pathname]:
    "事業所口座一覧",
  [pagesPath.admin.list.bank_accounts.members.$url().pathname]:
    "加入者口座一覧",
  [pagesPath.admin.list.medical_checkups.reference_data.facilities.$url()
    .pathname]: "健診機関一覧",
  [pagesPath.admin.list.medical_checkups.reference_data.facilities.import.$url()
    .pathname]: "健診機関インポート",
  [pagesPath.admin.list.medical_checkups.reference_data.interview_questions.$url()
    .pathname]: "問診設問マスタ",
  [pagesPath.admin.list.medical_checkups.$url().pathname]: "健診予約一覧",
  [pagesPath.admin.list.medical_checkups.results.$url().pathname]:
    "健診結果一覧",
  [pagesPath.admin.list.medical_checkups.results.import.$url().pathname]:
    "健診結果・特定保健指導実績インポート",
  [pagesPath.admin.list.medical_checkups.results.reports.$url().pathname]:
    "随時提出・実績報告",
  [pagesPath.admin.list.medical_checkups.results.subsidy_docs.$url().pathname]:
    "補助金通知書一覧",
  [pagesPath.admin.list.medical_checkups.results.not_contract.$url().pathname]:
    "契約外健診結果一覧",
  [pagesPath.admin.list.medical_checkups.results.not_contract.create.$url()
    .pathname]: "契約外健診結果 新規登録",
  [pagesPath.admin.list.medical_checkups.results.not_contract.import.$url()
    .pathname]: "契約外健診結果 CSVインポート",
  [pagesPath.admin.list.medical_checkups.tokutei_hokenshido.$url().pathname]:
    "特定保健指導対象者一覧",
  [pagesPath.admin.list.medical_checkups.tokutei_hokenshido
    ._fiscalYear("")
    .import.$url().pathname]:
    "特定保健指導 運用情報CSV取込（{fiscalYear}年度）",
  [pagesPath.admin.list.stress_checks.$url().pathname]:
    "ストレスチェック実施状況一覧",
  [pagesPath.admin.list.stress_checks._campaignId("").$url().pathname]:
    "ストレスチェック実施詳細",
  [pagesPath.admin.list.emails.$url().pathname]: "Eメールアクティビティ",
  [pagesPath.admin.list.emails.bounces.$url().pathname]: "Eメールバウンス",

  [pagesPath.admin.list.applications.$url().pathname]: "申請",
  [pagesPath.admin.list.applications.hihuyousyaidoutodoke.$url().pathname]:
    "被扶養者異動届",
  [pagesPath.admin.list.applications.hihuyousyaidoutodoke
    ._applicationId("")
    .$url().pathname]: "家族状況報告書",
  [pagesPath.admin.list.applications.hihuyousyaidoutodoke
    ._applicationId("")
    .operation_logs.$url().pathname]: "被扶養者異動届操作ログ",
  [pagesPath.admin.list.applications.ryoyohitatekae.$url().pathname]:
    "療養費（立替払い）",
  [pagesPath.admin.list.applications.ryoyohitatekae.details.$url().pathname]:
    "療養費（立替払い）療養情報",
  [pagesPath.admin.list.applications.ryoyohitatekae
    ._applicationId("")
    .details._detailId("")
    .$url().pathname]: "療養費支給申請（立替払い）",
  [pagesPath.admin.list.applications.ryoyohitatekae
    ._applicationId("")
    .operation_logs.$url().pathname]: "療養費支給申請（立替払い）操作ログ",
  [pagesPath.admin.list.applications.shussanteatekin.$url().pathname]:
    "出産手当金支給申請",
  [pagesPath.admin.list.applications.shussanteatekin._applicationId("").$url()
    .pathname]: "出産手当金支給申請",
  [pagesPath.admin.list.applications.shussanteatekin
    ._applicationId("")
    .operation_logs.$url().pathname]: "出産手当金支給申請 操作ログ",
  [pagesPath.admin.list.notification_papers.$url().pathname]: "通知書管理",
  [pagesPath.admin.list.notification_papers.benefit_determination_dates.$url()
    .pathname]: "支給決定日一覧",
  [pagesPath.admin.list.notification_papers.benefit_determination_dates
    ._determinationDate("")
    .$url().pathname]: "支給決定日詳細",
  [pagesPath.admin.list.notification_papers.benefit_determination_dates
    ._determinationDate("")
    .operation_logs._insuranceNumberId("")
    .$url().pathname]: "支給決定通知書 操作ログ",

  [pagesPath.admin.list.applications.hifuyoushashikakukakunin.$url().pathname]:
    "被扶養者資格確認調査",
  [pagesPath.admin.list.applications.hifuyoushashikakukakunin.import.$url()
    .pathname]: "被扶養者資格確認調査 対象者インポート",
  [pagesPath.admin.list.applications.hifuyoushashikakukakunin
    ._applicationId("")
    .$url().pathname]: "被扶養者資格確認調査 詳細",
  [pagesPath.admin.list.applications.fuufukyoudoufuyoukakunin.$url().pathname]:
    "夫婦共同扶養確認調査",
  [pagesPath.admin.list.applications.fuufukyoudoufuyoukakunin.import.$url()
    .pathname]: "夫婦共同扶養確認調査 対象者インポート",
  [pagesPath.admin.list.applications.fuufukyoudoufuyoukakunin
    ._applicationId("")
    .$url().pathname]: "夫婦共同扶養確認調査 詳細",
  [pagesPath.admin.list.applications.hennyuujikennin.$url().pathname]:
    "編入時検認",
  [pagesPath.admin.list.applications.hennyuujikennin._applicationId("").$url()
    .pathname]: "編入時検認詳細",
  [pagesPath.admin.list.applications.hennyuujikennin.import.$url().pathname]:
    "編入時検認 依頼対象事業所選択",

  [pagesPath.admin.list.applications.ai_review_prompts.$url().pathname]:
    "AI審査（補助）設定",
  [pagesPath.admin.list.applications.ai_review_prompts
    ._applicationType("")
    .$url().pathname]: "AI審査（補助）設定",
  [pagesPath.admin.list.applications.ai_review_prompts
    ._applicationType("")
    .histories.$url().pathname]: "AI審査（補助）設定履歴",

  [pagesPath.admin.list.dev.email_delivery_queue_preview
    ._emailDeliveryQueueId("")
    .$url().pathname]: "email_delivery_queue プレビュー",
  [pagesPath.admin.list.dev.check_ai_connectivity.$url().pathname]:
    "AI疎通確認",
  [pagesPath.admin.list.dev.shussanteatekin_doctor_certificate_extraction.$url()
    .pathname]: "出産手当金 医師・助産師の証明の読み取り確認",

  [pagesPath.admin.login.$url().pathname]: "健保ログイン",

  [pagesPath.admin.$url().pathname]: "",
  [pagesPath.admin.list.$url().pathname]: "",
  [pagesPath.admin.logs_debug.$url().pathname]: "",
  [pagesPath.admin.ui.$url().pathname]: "UIコンポーネントショーケース",

  // 事業所（/employers）
  [pagesPath.employers._officeId("").account.setting.$url().pathname]:
    "マイページ",
  [pagesPath.employers._officeId("").office.$url().pathname]: "事業所情報",
  [pagesPath.employers._officeId("").in_app_notifications.$url().pathname]:
    "通知一覧",
  [pagesPath.employers._officeId("").in_app_notifications._id("").$url()
    .pathname]: "通知詳細",
  [pagesPath.employers._officeId("").news.$url().pathname]: "事業所お知らせ",

  // ストレスチェック
  [pagesPath.employers._officeId("").stress_check.$url().pathname]:
    "ストレスチェック実施回一覧",
  [pagesPath.employers._officeId("").stress_check.new.$url().pathname]:
    "ストレスチェック実施回の作成",
  [pagesPath.employers._officeId("").stress_check._campaignId("").$url()
    .pathname]: "ストレスチェック管理",
  [pagesPath.employers._officeId("").stress_check._campaignId("").import.$url()
    .pathname]: "ストレスチェック対象者のCSV一括登録",
  [pagesPath.employers
    ._officeId("")
    .stress_check._campaignId("")
    .group_analysis.$url().pathname]: "ストレスチェック集団分析",

  [pagesPath.employers._officeId("").applications.$url().pathname]: "各種届出",
  [pagesPath.employers._officeId("").applications.hihuyousyaidoutodoke.$url()
    .pathname]: "被扶養者異動届（扶養の追加）",
  [pagesPath.employers
    ._officeId("")
    .applications.hihuyousyaidoutodoke._applicationId("")
    .$url().pathname]: "家族状況報告書提出フォーム",
  [pagesPath.employers
    ._officeId("")
    .applications.hihuyousyaidoutodoke._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "家族状況報告書追加書類提出フォーム",
  [pagesPath.employers
    ._officeId("")
    .applications.hifuyoushashikakukakunin.$url().pathname]:
    "被扶養者資格確認調査（年次）",
  [pagesPath.employers._officeId("").applications.shussanteatekin.$url()
    .pathname]: "出産手当金支給申請",
  [pagesPath.employers._officeId("").applications.shussanteatekin.new.$url()
    .pathname]: "出産手当金支給申請",
  [pagesPath.employers
    ._officeId("")
    .applications.shussanteatekin._applicationId("")
    .$url().pathname]: "出産手当金支給申請",
  [pagesPath.employers
    ._officeId("")
    .applications.shussanteatekin._applicationId("")
    .basic_info.$url().pathname]: "出産手当金支給申請",
  [pagesPath.employers
    ._officeId("")
    .applications.shussanteatekin._applicationId("")
    .bank_account.$url().pathname]: "出産手当金支給申請",
  [pagesPath.employers
    ._officeId("")
    .applications.shussanteatekin._applicationId("")
    .supplementary_note.$url().pathname]: "出産手当金支給申請",
  [pagesPath.employers
    ._officeId("")
    .applications.shussanteatekin._applicationId("")
    .employer_certificate.$url().pathname]: "出産手当金支給申請",
  [pagesPath.employers
    ._officeId("")
    .applications.shussanteatekin._applicationId("")
    .documents._documentId("")
    .$url().pathname]: "出産手当金支給申請",
  [pagesPath.employers
    ._officeId("")
    .applications.shussanteatekin._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "出産手当金支給申請",
  [pagesPath.employers
    ._officeId("")
    .applications.hifuyoushashikakukakunin._applicationId("")
    .$url().pathname]: "被扶養者資格確認調査（年次）",
  [pagesPath.employers
    ._officeId("")
    .applications.hifuyoushashikakukakunin._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "被扶養者資格確認調査 追加書類提出",
  [pagesPath.employers
    ._officeId("")
    .applications.fuufukyoudoufuyoukakunin.$url().pathname]:
    "夫婦共同扶養確認調査",
  [pagesPath.employers
    ._officeId("")
    .applications.fuufukyoudoufuyoukakunin._applicationId("")
    .$url().pathname]: "夫婦共同扶養確認調査",
  [pagesPath.employers
    ._officeId("")
    .applications.fuufukyoudoufuyoukakunin._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "夫婦共同扶養確認調査 追加書類提出",

  [pagesPath.employers._officeId("").offers.$url().pathname]: "特典サービス",
  [pagesPath.employers._officeId("").offers._id("").$url().pathname]:
    "特典サービス",
  [pagesPath.employers._officeId("").medical_checkups.$url().pathname]:
    "健康診断",
  [pagesPath.employers._officeId("").medical_checkups._fiscalYear("").$url()
    .pathname]: "{fiscalYear}年度：健康診断",
  [pagesPath.employers._officeId("").medical_checkups.import.$url().pathname]:
    "健診予約情報一括登録・更新",
  [pagesPath.employers
    ._officeId("")
    .medical_checkups._fiscalYear("")
    .import.$url().pathname]: "{fiscalYear}年度：健診予約情報一括登録・更新",
  [pagesPath.employers._officeId("").medical_checkups.facilities.$url()
    .pathname]: "健診機関一覧",
  [pagesPath.employers
    ._officeId("")
    .medical_checkups._fiscalYear("")
    .facilities.$url().pathname]: "{fiscalYear}年度：健診機関一覧",
  [pagesPath.employers
    ._officeId("")
    .medical_checkups._fiscalYear("")
    .facilities._facilityCode("")
    .$url().pathname]: "{fiscalYear}年度：健診料金",
  [pagesPath.employers
    ._officeId("")
    .medical_checkups._fiscalYear("")
    .reminder_exclusion.reservation.$url().pathname]:
    "{fiscalYear}年度：健診未予約者リマインド送信対象設定",
  [pagesPath.employers
    ._officeId("")
    .medical_checkups._fiscalYear("")
    .reminder_exclusion.interview_answer.$url().pathname]:
    "{fiscalYear}年度：問診未回答者リマインド送信対象設定",
  [pagesPath.employers
    ._officeId("")
    .medical_checkups._fiscalYear("")
    .results.$url().pathname]: "{fiscalYear}年度：補助金ステータス管理",
  [pagesPath.employers._officeId("").medical_checkups.subsidy_docs.$url()
    .pathname]: "補助金通知書一覧",
  [pagesPath.employers._officeId("").dashboard.$url().pathname]:
    "ダッシュボード",
  [pagesPath.employers._officeId("").office_members.$url().pathname]:
    "被保険者",
  [pagesPath.employers._officeId("").$url().pathname]: "",
  [pagesPath.employers.forgot_password.$url().pathname]:
    "事業所パスワード再発行",
  [pagesPath.employers.login_with_otp.$url().pathname]:
    "事業所ワンタイムパスワード",
  [pagesPath.employers.invitation._inviteCode("").login.$url().pathname]:
    "事業所ログイン",
  [pagesPath.employers.invitation._inviteCode("").signup.$url().pathname]:
    "事業所サインアップ",
  [pagesPath.employers.invitation._inviteCode("").$url().pathname]:
    "事業所招待",
  [pagesPath.employers.login.$url().pathname]: "mykenpo事業所ログイン",
  [pagesPath.employers.logout.$url().pathname]: "事業所ログアウト",
  [pagesPath.employers.reset_password.$url().pathname]:
    "事業所パスワード再設定",
  [pagesPath.employers.mfa.$url().pathname]: "事業所MFAコード入力",
  [pagesPath.employers.$url().pathname]: "",

  // 加入者（/members）
  [pagesPath.members.stress_check._token("").$url().pathname]:
    "ストレスチェック受検",
  [pagesPath.members.stress_check.result._token("").$url().pathname]:
    "ストレスチェック結果",
  [pagesPath.members.stress_check_results.$url().pathname]:
    "ストレスチェック受検履歴",
  [pagesPath.members.stress_check_results._responseId("").$url().pathname]:
    "ストレスチェック結果",
  [pagesPath.members.account.setting.$url().pathname]: "アカウント設定",
  [pagesPath.members.applications.$url().pathname]: "各種届出",
  [pagesPath.members.applications.hihuyousyaidoutodoke.$url().pathname]:
    "被扶養者異動届（扶養の追加）",
  [pagesPath.members.applications.hihuyousyaidoutodoke._applicationId("").$url()
    .pathname]: "家族状況報告書提出フォーム",
  [pagesPath.members.applications.hihuyousyaidoutodoke
    ._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "家族状況報告書追加書類提出フォーム",
  [pagesPath.members.applications.fuufukyoudoufuyoukakunin.$url().pathname]:
    "夫婦共同扶養確認調査",
  [pagesPath.members.applications.fuufukyoudoufuyoukakunin
    ._applicationId("")
    .$url().pathname]: "夫婦共同扶養確認調査",
  [pagesPath.members.applications.fuufukyoudoufuyoukakunin
    ._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "夫婦共同扶養確認調査 追加書類提出",
  [pagesPath.members.applications.benefit_notification_papers.$url().pathname]:
    "給付関連の通知書一覧",
  [pagesPath.members.applications.hifuyoushashikakukakunin.$url().pathname]:
    "被扶養者資格確認調査（年次）",
  [pagesPath.members.applications.hennyuujikennin.$url().pathname]:
    "編入時検認",
  [pagesPath.members.applications.hennyuujikennin._applicationId("").$url()
    .pathname]: "編入時検認",
  [pagesPath.members.applications.hennyuujikennin
    ._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "編入時検認 追加書類提出",
  [pagesPath.members.applications.hifuyoushashikakukakunin
    ._applicationId("")
    .$url().pathname]: "被扶養者資格確認調査（年次）",
  [pagesPath.members.applications.hifuyoushashikakukakunin
    ._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "被扶養者資格確認調査 追加書類提出",
  [pagesPath.members.applications.ryoyohitatekae.$url().pathname]:
    "療養費支給申請（立替払い）",
  [pagesPath.members.applications.ryoyohitatekae.new.$url().pathname]:
    "療養費支給申請（立替払い）",
  [pagesPath.members.applications.ryoyohitatekae._applicationId("").$url()
    .pathname]: "療養費支給申請（立替払い）",
  [pagesPath.members.applications.ryoyohitatekae
    ._applicationId("")
    .bank_account.$url().pathname]: "療養費支給申請（立替払い）",
  [pagesPath.members.applications.ryoyohitatekae
    ._applicationId("")
    .reseputo.$url().pathname]: "療養費支給申請（立替払い）",
  [pagesPath.members.applications.ryoyohitatekae
    ._applicationId("")
    .complete.$url().pathname]: "療養費支給申請（立替払い）",
  [pagesPath.members.applications.ryoyohitatekae
    ._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "療養費支給申請（立替払い） 追加書類提出",
  [pagesPath.members.applications.ryoyohitatekae
    ._applicationId("")
    .details._detailId("")
    .$url().pathname]: "療養費支給申請（立替払い）",
  [pagesPath.members.applications.ryoyohitatekae_receipt_extraction_preview.$url()
    .pathname]: "領収書読み取り 動作確認",

  [pagesPath.members.applications.shussanteatekin.$url().pathname]:
    "出産手当金支給申請",
  [pagesPath.members.applications.shussanteatekin.new.$url().pathname]:
    "出産手当金支給申請",
  [pagesPath.members.applications.shussanteatekin._applicationId("").$url()
    .pathname]: "出産手当金支給申請",
  [pagesPath.members.applications.shussanteatekin
    ._applicationId("")
    .basic_info.$url().pathname]: "出産手当金支給申請",
  [pagesPath.members.applications.shussanteatekin
    ._applicationId("")
    .bank_account.$url().pathname]: "出産手当金支給申請",
  [pagesPath.members.applications.shussanteatekin
    ._applicationId("")
    .supplementary_note.$url().pathname]: "出産手当金支給申請",
  [pagesPath.members.applications.shussanteatekin
    ._applicationId("")
    .documents._documentId("")
    .$url().pathname]: "出産手当金支給申請",
  [pagesPath.members.applications.shussanteatekin
    ._applicationId("")
    .additional_documents._requestId("")
    .$url().pathname]: "出産手当金支給申請",

  [pagesPath.members.offers.$url().pathname]: "特典サービス",
  [pagesPath.members.offers._id("").$url().pathname]: "特典サービス",

  [pagesPath.members.medical_checkups.$url().pathname]: "健康診断",
  [pagesPath.members.medical_checkups._fiscalYear("").$url().pathname]:
    "{fiscalYear}年度：健康診断",
  [pagesPath.members.medical_checkups._fiscalYear("").results.$url().pathname]:
    "{fiscalYear}年度：補助金ステータス管理",
  [pagesPath.members.insurance_card.$url().pathname]: "保険資格",
  [pagesPath.members.medical_checkups.facilities.$url().pathname]:
    "健診機関一覧",
  [pagesPath.members.medical_checkups._fiscalYear("").facilities.$url()
    .pathname]: "{fiscalYear}年度：健診機関一覧",
  [pagesPath.members.medical_checkups.upsert.$url().pathname]: "健康診断予約",
  [pagesPath.members.medical_checkups._fiscalYear("").upsert.$url().pathname]:
    "{fiscalYear}年度：健康診断の予約完了の報告",
  [pagesPath.members.medical_checkups._fiscalYear("").not_contract_upsert.$url()
    .pathname]: "{fiscalYear}年度：契約外健診機関での予約完了報告・問診回答",
  [pagesPath.members.medical_checkups
    ._fiscalYear("")
    .not_contract_upsert.finish.$url().pathname]:
    "{fiscalYear}年度：契約外健診機関での予約完了報告・問診回答完了",
  [pagesPath.members.medical_checkups._fiscalYear("").interview.$url()
    .pathname]: "{fiscalYear}年度：事前問診",
  [pagesPath.members.medical_checkups._fiscalYear("").interview.finish.$url()
    .pathname]: "{fiscalYear}年度：事前問診回答完了",
  [pagesPath.members.medical_checkups_interview._fiscalYear("").$url()
    .pathname]: "{fiscalYear}年度：事前問診",
  [pagesPath.members.medical_checkups_interview._fiscalYear("").finish.$url()
    .pathname]: "{fiscalYear}年度：事前問診回答完了",
  [pagesPath.members.dependents.medical_checkups
    ._fiscalYear("")
    ._insuranceNumberId("")
    .upsert.$url().pathname]: "{fiscalYear}年度：被扶養者健診予約登録",
  [pagesPath.members.dependents.medical_checkups
    ._fiscalYear("")
    ._insuranceNumberId("")
    .facilities.$url().pathname]: "{fiscalYear}年度：被扶養者健診機関検索",
  [pagesPath.members.dependents.medical_checkups
    ._fiscalYear("")
    ._insuranceNumberId("")
    .interview_answer.$url().pathname]:
    "{fiscalYear}年度：被扶養者健診問診回答",
  [pagesPath.members.dependents.medical_checkups
    ._fiscalYear("")
    ._insuranceNumberId("")
    .interview_answer.finish.$url().pathname]:
    "{fiscalYear}年度：被扶養者健診問診回答完了",
  [pagesPath.members.news.$url().pathname]: "加入者お知らせ",
  [pagesPath.members.$url().pathname]: "",
  [pagesPath.members.forgot_password.$url().pathname]: "加入者パスワード再発行",
  [pagesPath.members.login_with_otp.$url().pathname]:
    "加入者ワンタイムパスワード",
  [pagesPath.members.login.$url().pathname]: "mykenpo加入者ログイン",
  [pagesPath.members.logout.$url().pathname]: "加入者ログアウト",
  [pagesPath.members.reset_password.$url().pathname]: "加入者パスワード再設定",
  [pagesPath.members.signup.$url().pathname]: "mykenpo加入者サインアップ",
  [pagesPath.members.verify_account.$url().pathname]: "本人確認方式選択",
  [pagesPath.members.verify_account.auth_code.$url().pathname]:
    "加入者認証コード入力",
  [pagesPath.members.verify_account.digital_auth.$url().pathname]:
    "マイナンバーカードでの本人確認",
  [pagesPath.members.mfa.$url().pathname]: "加入者MFAコード入力",
  [pagesPath.members.in_app_notifications.$url().pathname]: "通知一覧",
  [pagesPath.members.in_app_notifications._id("").$url().pathname]: "通知詳細",
  [pagesPath.$url().pathname]: "",
} as const satisfies Record<PagesPathname, string>;
